<template>
  <vk-modal :has-close-icon="true" @close="$emit('secondary')">
    <div class="SURVEY-BODY">
      <vk-modal-header class="text-bold c-depot">
        <span class="c-gray80 p-l-3">Survey</span>
      </vk-modal-header>
      <vk-modal-content v-if="showSurveyStart" class="CONTENT">
        Pro Referral wants to learn about your ideal number of leads per occupation.
        <br>You have {{ numberOfOccupationsText }} in your profile.
        <br><br>We value your feedback to help us improve your experience in the future!
      </vk-modal-content>
      <vk-modal-content v-else class=" d-flex fd-column p-0 p-b-2">
        <div class="SURVEY-QUESTION">
          How many <span class="text-bold">
            {{ currentSurveyOccupation }}
          </span> leads can you take on per month?
        </div>
        <div
            v-for="({value, displayText}, key,) in $options.ONE_TIME_SURVEY_OPTIONS"
            :key="key"
            class="radio RADIO text-left d-block">
          <input
              :id="key"
              :value="value"
              v-model="selectedAnswer"
              type="radio"
              name="survey_question">
          <label :for="key" class="SCALED-RADIO">
            {{ displayText }}
          </label>
        </div>
      </vk-modal-content>
      <vk-modal-footer v-if="showSurveyStart" class="FOOTER">
        <button
            class="BUTTON-SECONDARY"

            @click.prevent="$emit('secondary')">
          Snooze
        </button>
        <button
            class="BUTTON-PRIMARY"
            @click.prevent="nextIndex">
          Start
        </button>
      </vk-modal-footer>
      <vk-modal-footer v-else class="FOOTER">
        <button
            class="BUTTON-SECONDARY"
            :disabled="submitting"
            @click.prevent="onClickBack">
          Back
        </button>
        <button
            class="BUTTON-PRIMARY"
            :disabled="disabled"
            @click.prevent="onPrimarySurveyClick">
          {{ primaryButtonLabel }}
        </button>
      </vk-modal-footer>
    </div>
  </vk-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import http from '@homeservices/api-kit/axios';
import { ONE_TIME_SURVEY_OPTIONS } from '@/constants/one-time-survey-options';
import SlidingModal from './SlidingModal';

export default {
  ONE_TIME_SURVEY_OPTIONS,
  name: 'one-time-survey-modal',
  components: {
    SlidingModal,
  },
  data () {
    return {
      submitting: false,
      activeIndex: -1,
      selectedAnswer: '',
      selectedAnswers: [],
    };
  },
  computed: {
    ...mapGetters('account/pro', [
      'serviceProvidersIds',
      'serviceProviderCatalogOccupations',
    ]),
    showSurveyStart () {
      return this.activeIndex < 0;
    },
    primaryButtonLabel () {
      return this.activeIndex === this.numberOfOccupations - 1 ? 'Submit' : 'Next';
    },
    currentSurveyOccupation () {
      return this.currentOccupation.occupation.display_name;
    },
    numberOfOccupationsText () {
      return this.numberOfOccupations > 1 ? `${this.numberOfOccupations} occupations` : `${this.numberOfOccupations} occupation`;
    },
    numberOfOccupations () {
      return Object.keys(this.serviceProviderCatalogOccupations).length;
    },
    disabled () {
      return this.submitting || !this.selectedAnswer;
    },
    currentOccupation () {
      return this.serviceProviderCatalogOccupations[
        Object.keys(this.serviceProviderCatalogOccupations)[this.activeIndex]
      ];
    },
  },
  methods: {
    onClickBack () {
      this.activeIndex -= 1;
    },
    nextIndex () {
      this.activeIndex += 1;
    },
    onPrimarySurveyClick () {
      this.selectedAnswers.push({
        service_provider_occupation_id: this.currentOccupation.occupation_id,
        service_provider_occupation_attribute_value: this.selectedAnswer,
      });
      if (this.activeIndex === this.numberOfOccupations - 1) {
        this.submit();
      } else {
        this.selectedAnswer = '';
        this.nextIndex();
      }
    },
    async submit () {
      this.submitting = true;
      await this.submitSurvey();
      this.submitting = false;
      this.$emit('secondary');
    },
    async submitSurvey () {
      try {
        await http.post(`/platform/serviceprovider/r/service-provider-occupations/survey/${this.serviceProvidersIds[0]}/v1`,
          this.selectedAnswers
        );
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/constants";

  .SURVEY-BODY {
    @include responsive(min-width, 100%, $survey-modal-width);
    @include responsive(width, 100%, $survey-modal-width);
    @include responsive(max-width, 100%, $survey-modal-width);
    display: flex;
    flex-direction: column;

  }
  .SURVEY-QUESTION {
    padding: 1.5*$unit 9*$unit;
    @include mobile-only() {
      padding: 1.5*$unit 6*$unit;
    }
  }
  .RADIO {
    display: flex;
    padding: 1.5*$unit 12*$unit;
    border-top: 1px solid $color-gray30;

  }
  .SCALED-RADIO {
    &:before {
      width: 2.5*$unit;
      height: 2.5*$unit;
      margin-right: 2*$unit;
      border: 3px solid $color-gray70;
    }
  }
  .HEADER {
    @include h6;
    background-color: white;
    padding: $unit;
    font-weight: 700;
    text-align: center;
    border-bottom: 1px solid $color-gray30;
  }

  .CONTENT {
    background-color: white;
    padding: 2*$unit 8*$unit 11*$unit;
    text-align: center;
    line-height: 3.5 * $unit;
    font-weight: 500;
    @include mobile-only() {
      padding: 2*$unit 5*$unit 11*$unit;
    }
  }

  .FOOTER {
    display: flex;
    padding: 0 6*$unit 3*$unit;
    background-color: white;
  }

  .BUTTON-SECONDARY,
  .BUTTON-PRIMARY {
    @include button-medium;
    display: flex;
    flex: 1 1 auto;
    font-weight: 600;
    width: 17 * $unit;
  }

  .BUTTON-SECONDARY {
    @include button-secondary;
    margin-right: 1.5*$unit;
    padding-left: 1.5*$unit;
  }

  .BUTTON-PRIMARY {
    @include button-primary;
    margin-left: 1.5*$unit;
  }
</style>
